export default __webpack_public_path__ + "static/media/IMG-20241005-WA0050.50168efc.jpg";